import { render, staticRenderFns } from "./UserWalletHistory.vue?vue&type=template&id=68db397b&scoped=true&"
import script from "./UserWalletHistory.vue?vue&type=script&lang=js&"
export * from "./UserWalletHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserWalletHistory.vue?vue&type=style&index=0&id=68db397b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68db397b",
  null
  
)

export default component.exports